import { usePathname } from "expo-router";
import { useEffect } from "react";
import { usePodcastPlayerStore } from "../hooks/usePodcastPlayerStore";
import { FloatingPodcastPlayer } from "./FloatingPodcastPlayer";

const GlobalPodcastPlayer = () => {
	const visible = usePodcastPlayerStore((store) => store.visible);
	const showGlobalPlayer = usePodcastPlayerStore(
		(store) => store.showGlobalPlayer,
	);
	const setShowGlobalPlayer = usePodcastPlayerStore(
		(store) => store.setShowGlobalPlayer,
	);

	const pathname = usePathname();

	useEffect(() => {
		setShowGlobalPlayer(!pathname.includes("/podcasts/"));
	}, [pathname, setShowGlobalPlayer]);

	if (!(visible && showGlobalPlayer)) {
		return null;
	}

	return <FloatingPodcastPlayer />;
};

export default GlobalPodcastPlayer;
